<template>
<section class="hero is-info is-fullheight" :style="layoutStyles">
  <Snow />
  <div class="hero-body">
    <div class="container has-text-centered box back-dark">
          <launcher />
    </div>
  </div>
</section>
</template>

<script>
import Launcher from '@/views/Launcher'
import Snow from '@/components/Snowf'
export default {
    name: 'LauncherLayout',
    components: {
        Launcher,
        Snow
    },
    created() {
      this.$http.get(this.api+this.endpoint).then( response => {
        this.$store.dispatch('generalConfig', response.data)
      })
    },
    computed: {
      endpoint() {
        return this.$store.getters.GetEndpoints.general
      },
      api() {
        return this.$store.getters.GetApiPath
      },
        layoutStyles() {
            return {
            'background': 'url("/images/back01-min.jpg") no-repeat',
            'background-position': 'center',
            'background-size':'cover'
            }
        }
    }
}
</script>

<style>

</style>